interface Props {
    words: string;
}

const Subtitle = ({ words }: Props) => {
    return <h3 className="mb-2 text-lg font-semibold text-slate-600">{words}</h3>;
};

export default Subtitle;
